import React, { useEffect, useState } from 'react';
import StandardGraphAxisTable from './StandardGraphAxisTable';
import { BOOTSTRAP_BREAKPOINTS, checkBreakpoint } from '@awp/helpers/UIHelper';
import { GetJson } from '@awp/helpers/fetchReact';
import { REST_API } from '@awp/constants';
import { debounce } from '@awp/helpers/Utils';
import { AwpContainer } from '../Common/AwpContainer';
import { UrlParamTableFilterContextProvider } from '@providers/UrlParamTableFilterContext';

const StandardGraphAxis = () => {
  const [isMedium, setIsMedium] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
  const [isLarge, setIsLarge] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.LARGE));
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    setLoading(true);
    const url = REST_API.STANDARD_GRAPH_AXIS;
    GetJson(url)
      .then((response) => response.json())
      .then((data) => {
        setData(data);
        setFilteredData(data);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const handleResize = debounce(() => {
      setIsMedium(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
      setIsLarge(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.LARGE));
    }, 100);

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  const tableProps = {
    data,
    setData,
    loading,
    filteredData,
    setFilteredData,
  };

  return (
    <AwpContainer>
      <UrlParamTableFilterContextProvider>
        <StandardGraphAxisTable {...tableProps} />
      </UrlParamTableFilterContextProvider>
    </AwpContainer>
  );
};

export default StandardGraphAxis;
